export enum EditMode {
    Add,
    Edit,
    Copy
}